import React from 'react';
import PropTypes from 'prop-types';
import { object, mixed } from 'yup';
import { Row, Col } from 'react-bootstrap';
import { Alert, Modal, Button } from '@storable/canaveral-components';
import withForm from '../../hocs/withForm';
import FormFieldFileUpload from '../FormFieldFileUpload';
import FormSubmitButton from '../FormSubmitButton';
import styles from './styles.scss';

const propTypes = {
  dirty: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  submitted: PropTypes.bool,
  submitting: PropTypes.bool,
  submitErrors: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
  })),
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

const defaultProps = {
  submitted: undefined,
  submitting: undefined,
  submitErrors: undefined,
};

const initialValues = {
  csv: '',
};

const validationSchema = object().shape({
  csv: mixed(),
});

const RedirectsEditFormModal = ({
  dirty,
  handleSubmit,
  isValid,
  submitted,
  submitting,
  submitErrors,
  show,
  onDismiss,
}) => {
  const submitDisabled = submitting || !dirty || !isValid;

  return (
    <Modal show={show} onDismiss={onDismiss}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Upload Redirects</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <FormFieldFileUpload
                accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                label="Upload CSV"
                description={'Rows must be formatted as "hostname, source URL, target URL"'}
                name="csv"
                className={styles.upload}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              {submitted && (
                <Alert context="success">
              Redirects successfully saved
                </Alert>
              )}
              {!submitting && submitErrors && (
                <Alert context="danger">
                  {submitErrors.map(err => (
                    <span key={err.code}>
                      {err.message}&nbsp;
                    </span>
                  ))}
                </Alert>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <FormSubmitButton
            disabled={submitDisabled}
            submitting={submitting}
            size="sm"
          />
          <Button
            context="neutral"
            onClick={onDismiss}
            size="sm"
            disabled={submitting}
          >
            {submitted ? 'Close' : 'Cancel'}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

RedirectsEditFormModal.propTypes = propTypes;
RedirectsEditFormModal.defaultProps = defaultProps;

export default withForm({
  mapPropsToValues: () => initialValues,
  validationSchema,
  handleSubmit: (values, formikBag) => formikBag.props.onSubmit(values),
})(RedirectsEditFormModal);
